import React, { useState } from 'react';

import { WashSaleGroup } from '@ndvr/portfolio-api';

import { CreateEditWashSaleGroup } from './CreateEditWashSaleGroup';
import { WashSaleGroupsList } from './WashSaleGroupsList';

export const WashSaleGroups = () => {
    const { isCreating, selectedGroup, startCreation, startEdit, reset } = useWashSaleGroupsState();

    return isCreating ? (
        <CreateEditWashSaleGroup onCancel={reset} selectedGroup={selectedGroup} />
    ) : (
        <WashSaleGroupsList onCreate={startCreation} onEdit={startEdit} />
    );
};

const useWashSaleGroupsState = () => {
    const [isCreating, setIsCreating] = useState(false);
    const [selectedGroup, setSelectedGroup] = useState<WashSaleGroup | undefined>();

    const startCreation = () => {
        setIsCreating(true);
        setSelectedGroup(undefined);
    };
    const startEdit = (washSaleGroup: WashSaleGroup) => {
        setIsCreating(true);
        setSelectedGroup(washSaleGroup);
    };
    const reset = () => {
        setIsCreating(false);
        setSelectedGroup(undefined);
    };

    return {
        isCreating,
        selectedGroup,
        startCreation,
        startEdit,
        reset,
    };
};
